/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ period: NonNullable<unknown> }} Progress_Report_Insufficient_NoteInputs */

const en_us2_progress_report_insufficient_note = /** @type {(inputs: Progress_Report_Insufficient_NoteInputs) => LocalizedString} */ (i) => {
	if (i?.period === "week") return /** @type {LocalizedString} */ (`An exercise needs to show up in 3 of the last 5 weeks to have a trend: one session alone doesn't decide.`);
	return /** @type {LocalizedString} */ (`An exercise needs to show up in 3 of the last 5 months to have a trend: one session alone doesn't decide.`)
	
};

const pt_br2_progress_report_insufficient_note = /** @type {(inputs: Progress_Report_Insufficient_NoteInputs) => LocalizedString} */ (i) => {
	if (i?.period === "week") return /** @type {LocalizedString} */ (`Um exercício precisa aparecer em 3 das últimas 5 semanas para ter tendência: uma sessão sozinha não decide.`);
	return /** @type {LocalizedString} */ (`Um exercício precisa aparecer em 3 dos últimos 5 meses para ter tendência: uma sessão sozinha não decide.`)
	
};

const es_419_progress_report_insufficient_note = /** @type {(inputs: Progress_Report_Insufficient_NoteInputs) => LocalizedString} */ (i) => {
	if (i?.period === "week") return /** @type {LocalizedString} */ (`Un ejercicio necesita aparecer en 3 de las últimas 5 semanas para tener tendencia: una sola sesión no decide.`);
	return /** @type {LocalizedString} */ (`Un ejercicio necesita aparecer en 3 de los últimos 5 meses para tener tendencia: una sola sesión no decide.`)
	
};

const pt_pt2_progress_report_insufficient_note = /** @type {(inputs: Progress_Report_Insufficient_NoteInputs) => LocalizedString} */ (i) => {
	if (i?.period === "week") return /** @type {LocalizedString} */ (`Um exercício tem de aparecer em 3 das últimas 5 semanas para ter tendência: uma sessão sozinha não decide.`);
	return /** @type {LocalizedString} */ (`Um exercício tem de aparecer em 3 dos últimos 5 meses para ter tendência: uma sessão sozinha não decide.`)
	
};

const fr_fr2_progress_report_insufficient_note = /** @type {(inputs: Progress_Report_Insufficient_NoteInputs) => LocalizedString} */ (i) => {
	if (i?.period === "week") return /** @type {LocalizedString} */ (`Un exercice doit apparaître dans 3 des 5 dernières semaines pour avoir une tendance : une seule séance ne suffit pas.`);
	return /** @type {LocalizedString} */ (`Un exercice doit apparaître dans 3 des 5 derniers mois pour avoir une tendance : une seule séance ne suffit pas.`)
	
};

const de_de2_progress_report_insufficient_note = /** @type {(inputs: Progress_Report_Insufficient_NoteInputs) => LocalizedString} */ (i) => {
	if (i?.period === "week") return /** @type {LocalizedString} */ (`Eine Übung muss in 3 der letzten 5 Wochen vorkommen, um einen Trend zu haben: Eine einzelne Einheit entscheidet nichts.`);
	return /** @type {LocalizedString} */ (`Eine Übung muss in 3 der letzten 5 Monate vorkommen, um einen Trend zu haben: Eine einzelne Einheit entscheidet nichts.`)
	
};

const it_it2_progress_report_insufficient_note = /** @type {(inputs: Progress_Report_Insufficient_NoteInputs) => LocalizedString} */ (i) => {
	if (i?.period === "week") return /** @type {LocalizedString} */ (`Un esercizio deve comparire in 3 delle ultime 5 settimane per avere un andamento: una sessione da sola non basta.`);
	return /** @type {LocalizedString} */ (`Un esercizio deve comparire in 3 degli ultimi 5 mesi per avere un andamento: una sessione da sola non basta.`)
	
};

/**
* | period | output |
* | --- | --- |
* | "week" | "An exercise needs to show up in 3 of the last 5 weeks to have a trend: one session alone doesn't decide." |
* | * | "An exercise needs to show up in 3 of the last 5 months to have a trend: one session alone doesn't decide." |
*
* @param {Progress_Report_Insufficient_NoteInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const progress_report_insufficient_note = /** @type {((inputs: Progress_Report_Insufficient_NoteInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Progress_Report_Insufficient_NoteInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_progress_report_insufficient_note(inputs)
	if (locale === "es-419") return es_419_progress_report_insufficient_note(inputs)
	if (locale === "pt-PT") return pt_pt2_progress_report_insufficient_note(inputs)
	if (locale === "fr-FR") return fr_fr2_progress_report_insufficient_note(inputs)
	if (locale === "de-DE") return de_de2_progress_report_insufficient_note(inputs)
	if (locale === "it-IT") return it_it2_progress_report_insufficient_note(inputs)
	return en_us2_progress_report_insufficient_note(inputs)
});
export { progress_report_insufficient_note as "progress-report.insufficient_note" }